import React from 'react'
import FormMin from '../forms/FormMin'
import InnerBotAvatar from './InnerBotAvatar'

export default function InnerFormMin({ message, isLastBotMessage,  setIsTyping, messages, setMessages, answers,setAnswers, urlBotImage }) {
    return (

        <div className='grid'>
            <InnerBotAvatar urlBotImage={urlBotImage} message={message} isLastBotMessage={isLastBotMessage} />
            <div className='col-10 pl-3'>
                <FormMin answers={answers} messages={messages} setMessages={setMessages} />
            </div>
        </div>

    )
}
